import axios from 'axios';
import _ from 'lodash-uuid';
import store from '@/store';
import messages, { MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import router from '@/router';
import helpers from './helpers';

const baseUrl = process.env.VUE_APP_BASE_DOMAIN + process.env.VUE_APP_BASE_PATH;
const apiKey = process.env.VUE_APP_API_KEY;
const timeout = process.env.VUE_APP_API_TIMEOUT;
const cancelControllerMap = new Map();

export const isAbort = (err) => {
    return axios.isCancel(err) || err?.name === 'CanceledError' || err?.name === 'AbortError' || err?.code === 'ERR_CANCELED';
};

const abortCancelKey = (cancelKey) => {
    if (!cancelKey) return;

    const controller = cancelControllerMap.get(cancelKey);
    if (!controller) return;

    controller.abort();
    cancelControllerMap.delete(cancelKey);
};

const abortAllCancelKeys = () => {
    cancelControllerMap.forEach((controller) => {
        controller.abort();
    });

    cancelControllerMap.clear();
};

const attachCancelKey = (config) => {
    const cancelKey = config?.cancelKey;
    if (!cancelKey) return config;

    abortCancelKey(cancelKey);

    const controller = new AbortController();
    config.signal = controller.signal;
    cancelControllerMap.set(cancelKey, controller);

    return config;
};

const cleanupCancelKey = (config) => {
    const cancelKey = config?.cancelKey;
    if (!cancelKey) return;

    const controller = cancelControllerMap.get(cancelKey);
    if (controller && controller.signal === config?.signal) {
        cancelControllerMap.delete(cancelKey);
    }
};

var repository = axios.create({
    baseURL: baseUrl,
    timeout: timeout,
    headers: {
        'x-api-key': apiKey
    }
});

repository.interceptors.request.use(
    function (config) {
        attachCancelKey(config);

        config.headers['x-request-id'] = _.uuid();
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        //const certificationcode = localStorage.getItem('certificationcode');
        if (window.location.pathname.startsWith('/mobile')) {
            //config.headers.certificationcode = certificationcode;
            const tokenMobile = localStorage.getItem('tokenMobile');
            //const tokenActive = localStorage.getItem('tokenMobileActive');
            //if (tokenMobile && tokenActive && tokenActive == 1) {
            if (tokenMobile) {
                config.headers.Authorization = `Bearer ${tokenMobile}`;
            } else {
                config.headers.Authorization = '';
            }
        }
        const clientCode = localStorage.getItem('clientcode');
        if (clientCode) {
            config.headers['clientcode'] = clientCode;
        }
        const isNoLoading = store.state.app.isNoLoading;
        //no loading for interval get notification
        const ignoreLoadingApis = ['move/getNotificationMessage', 'move/MNG_WorkReport002/getComments'];
        if (!ignoreLoadingApis.some((api) => config.url.includes(api))) {
            store.commit('app/showLoading');
        }
        if (!isNoLoading) {
            store.commit('app/increaseCountLoading');
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

repository.interceptors.response.use(
    function (response) {
        cleanupCancelKey(response?.config);

        const countLoading = store.state.app.countLoading;
        if (countLoading - 1 <= 0) {
            store.commit('app/hideLoading');
        }
        store.commit('app/decreaseCountLoading');

        const { data } = response;
        const skipGlobalErrorHandling = !!response?.config?.skipGlobalErrorHandling;

        if (data.Code !== 200 && !skipGlobalErrorHandling) {
            if (data.Code === 401) {
                // localStorage.clear();
                helpers.clearLocalStorageExcept(['listMenu']);

                if (router.currentRoute.value.name.includes('MNG')) {
                    router.push('/MNG_System/login');
                } else {
                    store.commit('app/showModalMessage', {
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E999,
                        content: messages.E401,
                        callback: () => {
                            router.push('/CUS_System/login');
                        }
                    });
                }
            } else if (data.Code === 403) {
                store.commit('app/showHeaderError', [messages.E403]);
            } else if (data.Code === 422) {
                let i = 0;
                for (const key in data.DataErrors) {
                    if (Object.prototype.hasOwnProperty.call(data.DataErrors, key) && i == 0) {
                        // const screenId = store.state.app.screenId;
                        const tbl = '';
                        store.commit('app/showHeaderError', [tbl + messages[data.DataErrors[key][0]]]);
                        i++;
                    }
                }
            } else if (data.Code === 423) {
                store.commit('app/showHeaderError', [data.Message]);
            } else if (data.Code === undefined) {
                //
            } else {
                store.commit('app/showHeaderError', [messages.E999]);
            }
            store.commit('app/hideForceLoading');
        }

        return response;
    },
    function (error) {
        cleanupCancelKey(error?.config);

        const countLoading = store.state.app.countLoading;
        if (countLoading - 1 <= 0) {
            store.commit('app/hideLoading');
            store.commit('app/hideForceLoading');
        }
        store.commit('app/decreaseCountLoading');
        if (!isAbort(error) && !error?.config?.skipGlobalErrorHandling) {
            store.commit('app/showHeaderError', [messages.E999]);
        }
        return Promise.reject(error);
    }
);

repository.abortCancelKey = abortCancelKey;
repository.abortAllCancelKeys = abortAllCancelKeys;
repository.isAbort = isAbort;

export default repository;
